import { render, staticRenderFns } from "./Dljz.vue?vue&type=template&id=94d04ea6&scoped=true&"
import script from "./Dljz.vue?vue&type=script&lang=js&"
export * from "./Dljz.vue?vue&type=script&lang=js&"
import style0 from "./Dljz.vue?vue&type=style&index=0&id=94d04ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d04ea6",
  null
  
)

export default component.exports